/* eslint-disable @typescript-eslint/naming-convention */
export const SUBNAVIGATION_LIST = [
  {
    jobSpecialCode: '1',
    hiringTypeCode: '1_1',
    imgUrl: require('../../imgs/campus/yingjiezhaopin.png'),
    title: '应届校招',
    bid: 'b_ead_82bupeug_mc',
  },
  {
    jobSpecialCode: '3',
    imgUrl: require('../../imgs/campus/beidoujihua.png'),
    title: '北斗计划',
    bid: 'b_ead_jjzv7y4j_mc',
  },
  {
    jobSpecialCode: '4',
    imgUrl: require('../../imgs/campus/qihang.png'),
    title: '启航计划',
    bid: 'b_ead_rfzj434l_mc',
  },
  {
    jobSpecialCode: '2',
    hiringTypeCode: '2_2',
    imgUrl: require('../../imgs/campus/zhuanzhengshixi.png'),
    title: '转正实习',
    bid: 'b_ead_ae6fnfia_mc',
  },
  {
    jobSpecialCode: '6',
    hiringTypeCode: '2_6',
    imgUrl: require('../../imgs/campus/richangshixi.png'),
    title: '日常实习',
    bid: 'b_ead_devwie6i_mc',
  },
];

export enum JOB_TYPE {
  YINGJIE = '1',
  SHIXI = '2',
  SOCIAL = '3',
}

export enum JOB_SPECIAL_CODE {
  YINGJIE = '1',
  ZHUANZHENGSHIXI = '2',
  BEIDOU = '3',
  QIHANG = '4',
  // 社招
  SOCIAL = '5',
  XIANGMUSHIXI = '6',
}

export const POSITION_STATE = {
  '1': '应届',
  '2': '实习',
  '3': '社招',
};
export const JOB_SPECIAL_STATE = {
  '1': '校园招聘',
  '2': '转正实习',
  '3': '北斗计划',
  '4': '零售启航计划',
  '5': '社会招聘',
  '6': '日常实习',
};

// 职位分享类型
export enum JOB_SHARE_TYPE {
  SOCIALBOLE = '2',
}

/**
 * 职位状态（下线or进行中）
 */
export enum JOB_STATUS {
  /**
   * 进行中
   */
  IN_RECRUITMENT = '000', // 进行中
}

// appKey
export const appKey = 'com.sankuai.recruitment.official.website';

export const SPECIAL_BTN_TIP = 'SPECIAL_BTN_TIP';
